import { ThreeView } from '../view3d/webcad';
import { LinkType } from '../webcad/collection/ItemInfoCollection';
import { APIManager } from '../webcad/manager';
import { CommonInfoData, FreeTextInfoData } from '../webcad/util/WebcadJSONExporter';
import { LiDARUnitBath } from './LiDARUnitBath';

export class WebViewData {

    constructor() {

    }

    public async execute(object) {
        // STARTSのフォーマットに変更
        const plan = object.plan;
        // 建具 fit15_01 → fit15_09
        plan.fitting = plan.fitting.map((item: CommonInfoData) => {
            if (item.id === 'fit15_01') {
                item.id = 'fit15_09';
            }
            return item;
        });
        // 汎用立方体 fur26_01 → fur28_02
        plan.furniture = plan.furniture.map((item: CommonInfoData) => {
            if (item.id === 'fur26_01') {
                item.id = 'fur28_02';
            }
            return item;
        });
        // UB の高さを初期値に
        LiDARUnitBath.applyToPlan(plan);

        const planningDocument = await APIManager.planningDocument(); // 企画ドキュメント取得
        plan.text = plan.text.map((item: FreeTextInfoData) => {
            item?.link?.forEach((link: LinkType) => {
                // 企画ドキュメントがあれば、先にpathをセット
                const _document = planningDocument?.find((doc) => doc.file_name == link.name);
                if (_document && _document.file_path != '') {
                    link.url = _document.file_path;
                    return;
                }

                // 既存データで企画ドキュメントを作成済みでLiDAR読み込みを実施した場合、企画ドキュメントにコピーされていないため
                // 物件ドキュメントを引き当てる必要がある。
                const document = ThreeView.get().buildingDocument?.docList?.find((doc) => doc.file_name == link.name);
                if (document && document.file_path != '') {
                    link.url = document.file_path;
                }
            });
            return item;
        });

        return object;
    }

}